module.exports = __webpack_public_path__ + "static/media/strategicpartner2.98c6c5ef.png";